export default __webpack_public_path__ + "static/media/fallout-video-thumb.8f61446d.png";